module.exports = __webpack_public_path__ + "static/media/main idea.8baaf2f3.mp3";